import { render, staticRenderFns } from "./fileRoleConfig.vue?vue&type=template&id=70d730fa&"
import script from "./fileRoleConfig.vue?vue&type=script&lang=ts&"
export * from "./fileRoleConfig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports